// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios' // 1、在这里引入axios

SERVER.APPID = localStorage.getItem('appId')

//全局工具
import utils from "./utils/utils.js";
Vue.prototype.$utils = utils
Vue.prototype.UTILS = utils

//全局轻提示
import toast from "./utils/vant.js";
Vue.prototype.$toast = toast

import routerHelper from "./utils/routerHelper.js";
Vue.prototype.$routerHelper = routerHelper

import ccRequest from "./utils/cc-webapp/request.js";
Vue.prototype.CCrequest = ccRequest


import VueI18n from 'vue-i18n'

import {
  CONFIG,
  SERVER,
  initEnv
} from "@/api/apiConfig.js";
Vue.prototype.CONFIG = CONFIG
Vue.prototype.SERVER = SERVER
Vue.prototype.DEV = SERVER.DEV
Vue.prototype.initEnv = initEnv


//引入註冊川辰混合開發框架底層全局方法
import GLOBAL from './utils/index.js'
Vue.prototype.GLOBAL_ = GLOBAL

//全局login方法
import loginFun from "./utils/cc-webapp/login.js";
Vue.prototype.LOGIN = loginFun

//全局login方法
import loginFun2 from "./utils/cc-webapp/login2.js";
Vue.prototype.LOGIN2 = loginFun2

import VueTouch from 'vue-touch';
Vue.use(VueTouch, {name: 'v-touch'});

Vue.use(VueI18n);

var i18n = ''
//开发环境
if (Vue.prototype.DEV) {
  Vue.prototype.$t = utils.langText

} else {
  let langData = localStorage.getItem("lang");
  let lang = "zh-hk";
  if (langData && JSON.parse(langData).type == true) {
    lang = JSON.parse(langData).lang
  }
  i18n = new VueI18n({
    locale: lang, // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-cn': require('./common/lang/zh.js'), // 中文语言包
      'zh-hk': require('./common/lang/tw.js') // 繁體语言包
    }
  })
  //var nativeData = JSON.parse(native.getDeviceInfo())
  //Vue.prototype.NATIVEDATA = nativeData
}


import 'vant/lib/index.css';
import "./assets/css/vantRewrite.css";
import Vant from 'vant';
import {NavBar, Tabbar, TabbarItem, Lazyload,Image as VanImage,Toast, Dialog, Loading , List ,Tab, Tabs, Icon, Popup, Sticky } from 'vant';
Vue.use(Vant);
Vue.use(NavBar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Lazyload, {lazyComponent: true});
Vue.use(VanImage);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(List);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Sticky);


//全局配置
import config from "./utils/config.js";
Vue.prototype.$config = config
Vue.prototype.DPR = window.devicePixelRatio

//全局样式
import "./assets/css/common.css";


//全局组件
import tabBar from './components/tabBar';
Vue.component('tabBar', tabBar);
import loading from './components/loading';
Vue.component('loading', loading);


Vue.config.productionTip = false

//显示console
import Vconsole from 'vconsole';
if (SERVER.CONSOLE) {
  new Vconsole();
}

import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Viewer.setDefaults({
  defaultOptions: {
    zIndex: 9999
  },
  Options: {
    'inline': false,//启用内敛模式
    'button': true,
    'navbar': false,//显示缩略图
    'title': true,//显示标题
    'toolbar': false,//工具栏按钮，可单独配置
    'tooltip': false,//工具提示
    'movable': true,//移动
    'zoomable': true,//缩放
    'rotatable': false,//旋转
    'scalable': false,//翻转
    'transition': false,//变换
    'fullscreen': false,//全屏
    'keyboard': false,
    // 'url': 'data-source'
  }
});

Vue.use(Viewer);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  to.meta.prevUrl = from.fullPath;
  next();
})

var vm = new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>',
  methods: {
  },
  created(){
    let url = window.location.href;
    this.$routerHelper.saveIndexQueryParams.call(this,url)
  }
  ,
  mounted(){
    //获取全局积分比例和单位
    GLOBAL.ccRequest.doAxios(CONFIG.RATECONFIG, {}, "GET")
      .then(res => {
        //console.log('RATECONFIG',res)
        let obj = res.data
        localStorage.setItem('rateConfig', JSON.stringify(obj));
      })
      .catch(err => {
        console.log(err);
      });

    // if(appid == 'mylink'){
    //   require("@/assets/css/mylink.css");
    // }

  }
})


// WEBPACK FOOTER //
// ./src/main.js